import PropTypes from 'prop-types';
import React from 'react';
import AddAppSiteButton from '../AddAppSiteButton';
import AppSitesTable from '../AppSitesTable';
import PageHeader from '../PageHeader';
import { partnerShape } from '../types';
import css from './BasePartnerAppSitesSummary.css';

export const SUMMARY_DATA_TEST_ID = 'app-sites-summary';

const BasePartnerAppSitesSummary = ({
    partner,
    appFilter = '',
    agencyFilter = '',
    onAppSiteForPartner = () => {},
    canAddAppSite = false,
}) => (
    <div className={css.appSitesSummary} data-testid={SUMMARY_DATA_TEST_ID}>
        <PageHeader partner={partner} />
        {canAddAppSite && (
            <AddAppSiteButton className={css.addAppSiteButton} partner={partner} onAddAppSite={onAppSiteForPartner} />
        )}
        <AppSitesTable
            appFilter={appFilter}
            agencyFilter={agencyFilter}
            partner={partner}
            onAppSiteForPartner={onAppSiteForPartner}
        />
    </div>
);

BasePartnerAppSitesSummary.propTypes = {
    partner: partnerShape.isRequired,
    appFilter: PropTypes.string,
    agencyFilter: PropTypes.string,
    onAppSiteForPartner: PropTypes.func,
    canAddAppSite: PropTypes.bool,
};

export default BasePartnerAppSitesSummary;
